import React, { useRef, useState } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { Menu } from 'react-bootstrap/lib/Dropdown';
import DropdownToggle from 'react-bootstrap/lib/DropdownToggle';
import { connect } from 'react-redux';
// import ScrollBar from "ScrollBar";
import ConsoleStore from 'ConsoleStore';

import { fetchAiInsightsSelectedReportData } from '../../../../Actions/AiInsightsActions';


const HoverDropdown = ({ title, items, activeKey, isActive, fetchAiInsightsSelectedReportData, SymbolInfo }) => {
  const [open, setOpen] = useState(false);
  const tabRef = useRef(null);
  const menuRef = useRef(null);

  const handleMouseEnter = () => setOpen(true);

  const handleMouseLeave = () => {
    const isHoveringTab = tabRef.current?.matches(':hover');
    const isHoveringMenu = menuRef.current?.matches(':hover');
    if (!isHoveringTab && !isHoveringMenu) {
      setOpen(false);
    }
  };


  return (
    <div
      className="tab-button-wrapper"
      ref={tabRef}
    >
      <Dropdown
        id={`dropdown-${title?.replace(' ', '')}`}
        open={open}
        onToggle={() => { }} // Controlled manually
        onMouseEnter={() => handleMouseEnter()}
        onMouseLeave={() => handleMouseLeave()}
        bsStyle="default"
        className="tab-dropdown-wrapper"
      // className="tab-dropdown-wrapper custom-scroll-light"
      >
        <DropdownToggle
          bsStyle="default"
          className={`custom-dropdown-toggle ${open ? 'hover-dropdown-open' : ''} ${isActive ? 'active' : ''}`}
          noCaret
          onClick={(e) => {
            e.preventDefault()
          }}
        >
          {title}
        </DropdownToggle>
        <Menu
          // style={{
          //   height: items?.length < 4 ? items?.length * 27 + "px" : "81px"
          // }}
        >
          <div ref={menuRef}
          // id={`AiInsightsHeader${title?.replace(' ', '')}DropdownScroll`}
          >
            {items?.map((item) => (
              <MenuItem
                key={item.id}
                eventKey={item.id}
                active={activeKey === item.id}
                onClick={() => {
                  if (!item.isDisabled) {
                    fetchAiInsightsSelectedReportData(title, item.id);
                    ConsoleStore.trackUsage("MenuItemClicked", "", ["AI", item.label, "AI Insights", SymbolInfo.Symbol]);
                    setOpen(false);
                  }
                }}
                className={item.isDisabled ? 'disabled' : ''}
              >
                {<u className="icn-select" style={{ visibility: activeKey === item.id ? 'visible' : 'hidden' }}></u>}
                <span>{item.label}</span>
              </MenuItem>
            ))}
          </div>
          {/* <ScrollBar scrollId={`AiInsightsHeader${title?.replace(' ', '')}DropdownScroll`} vScroll={true} scrollOnHover={true} /> */}
        </Menu>
      </Dropdown>
    </div>
  );
};

const mapStateToProps = ({ DatagraphReducers }) => {

  const { SymbolInfo } = DatagraphReducers.DataGraphReducer;

  return { SymbolInfo };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAiInsightsSelectedReportData: (selectedCategory, selectedSubCategoryId) => dispatch(fetchAiInsightsSelectedReportData(selectedCategory, selectedSubCategoryId))
});


export default connect(mapStateToProps, mapDispatchToProps)(HoverDropdown);
